<mat-dialog-content class="modal-header"
  ><h2 mat-dialog-title>Mensaje</h2>
</mat-dialog-content>

<mat-dialog-content class="modal-body">
  {{mensage}}
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <!-- <button type="button" [mat-dialog-close]="true" class="btn btn-naranja"  mat-button>Ok</button>  -->
  <button type="button" class="btn btn-naranja" (click)="confirmado()" mat-button>Ok</button>
  <!-- (click)="confirmado()" -->
</mat-dialog-actions>
